import styles from './Separator.module.scss';

export const Separator = ({ className }) => {
  return <div className={styles.separator + ` ${className}`} />;
};
